import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Loader from "@amzn/meridian/loader";
import ErrorPage from "./utils/ErrorPage";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import Column from "@amzn/meridian/column";
import {
    chainWalk,
    convertToString,
    formQueryParams,
    getFilteredLocations,
    getNodeId,
    getOrDefaultValueForCell
} from "../Utility";
import Link from "@amzn/meridian/link";
import {FormattedMessage} from "react-intl";
import {fetchBagsDataForSortZone} from "../actions/SortZoneActions";
import {PackageStatus} from "../enums";
import {getLocale} from "../handler/LocaleHandler";
import RefreshTimer from "./RefreshTimer";
import {FEATURES} from "../constants";

class SortZone extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expandedSortZones: [],
            sortColumn: "sortZone",
            sortDirection: "ascending"
        }
    }

    render() {
        const {
            loading, error, stowPackageMetricsMap, inductPackageMetricsMap, stowBagMetricsMap, ovUsageMap
        } = this.props;

        if (error) {
            return <ErrorPage errorId="stow.error" errorMessage="Some error occurred"/>
        }

        const sortZones = [
            ...Object.keys(stowPackageMetricsMap),
            ...Object.keys(stowBagMetricsMap),
            ...Object.keys(inductPackageMetricsMap),
            ...Object.keys(ovUsageMap)
        ];

        const distinctSortZones = [...new Set(sortZones)];

        if (loading && !distinctSortZones.length) {
            return (
                <Column
                    height="400px"
                    alignmentHorizontal="center"
                >
                    <Loader/>
                </Column>
            );
        }

        const filteredZones = getFilteredLocations(distinctSortZones, stowPackageMetricsMap, this.isDRSStowVisibilityEnabled());

        const onSort = (sortDetails) => {
            this.setState({
                sortColumn: sortDetails.sortColumn,
                sortDirection: sortDetails.sortDirection
            })
        }
        function customCompare(a, b) {
            return convertToString(a)
                .localeCompare(convertToString(b), getLocale(), {numeric: true});
        }

        const sortColumn = this.state.sortColumn;
        const direction = this.state.sortDirection;
        filteredZones.sort((s1, s2) => {
            const s1CombinedMetricsMap = this.getCombinedMetricsMap(s1);
            const s2CombinedMetricsMap = this.getCombinedMetricsMap(s2);
            if (direction === "ascending") {
                return customCompare(s1CombinedMetricsMap[sortColumn],s2CombinedMetricsMap[sortColumn])
            } else {
                return customCompare(s2CombinedMetricsMap[sortColumn],s1CombinedMetricsMap[sortColumn])
            }
        });

        return (
            <Column>
                <RefreshTimer deps={[stowPackageMetricsMap]} />
                <Table headerRows={2} showDividers={false} showStripes={false} spacing="small" fixHeaderRows={true}
                       fixHeaderRowsFullWidth={true}
                       sortColumn={this.state.sortColumn}
                       sortDirection={this.state.sortDirection}
                       onSort={onSort}
                       data-cy={"zoneTable"}>
                    {this.renderHeadings()}
                    {this.renderSubHeadings()}

                    {filteredZones.map((sortZone) => this.renderSortZoneRow(sortZone))}
                </Table>
            </Column>
        )
    }

    renderHeadings() {
        return (
            <TableRow>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="sortZone.bags" defaultMessage="Bags"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="sortZone.ov_capacity" defaultMessage="OV Capacity"/>
                </TableCell>
                <TableCell>
                    <FormattedMessage id="sortZone.packages" defaultMessage="Packages"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell/>
                <TableCell/>
            </TableRow>
        )
    }

    renderSubHeadings() {
        return (
            <TableRow>
                <TableCell sortColumn="sortZone">
                    <FormattedMessage id="sortZone.zone" defaultMessage="Zone"/>
                </TableCell>
                <TableCell sortColumn="plannedBags" alignmentHorizontal="right">
                    <FormattedMessage id="sortZone.planned" defaultMessage="Planned"/>
                </TableCell>
                <TableCell sortColumn="closedBags" alignmentHorizontal="right">
                    <FormattedMessage id="sortZone.closed" defaultMessage="Closed"/>
                </TableCell>
                <TableCell sortColumn="openBags" alignmentHorizontal="right">
                    <FormattedMessage id="sortZone.open" defaultMessage="Open"/>
                </TableCell>
                <TableCell sortColumn="ovUsage" alignmentHorizontal="right">
                    <FormattedMessage id="sortZone.used" defaultMessage="Used"/>
                </TableCell>
                <TableCell sortColumn="plannedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="sortZone.container_planned" defaultMessage="C. Planned"/>
                </TableCell>
                <TableCell sortColumn="receivedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="sortZone.arrived" defaultMessage="Arrived"/>
                </TableCell>
                <TableCell sortColumn="inductedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="sortZone.inducted" defaultMessage="Inducted"/>
                </TableCell>
                <TableCell sortColumn="stowedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="sortZone.stowed" defaultMessage="Stowed"/>
                </TableCell>
            </TableRow>
        )
    }

    renderSortZoneRow(sortZone) {
        const {
            bagsData
        } = this.props;

        const combinedMetricsMap = this.getCombinedMetricsMap(sortZone)

        return (
            <TableRow key={sortZone} open={this.isSortZoneExpanded(sortZone)} onClick={() => this.clickSortZoneRow(sortZone)} data-cy={"zoneDataRow"}>
                <TableCell>{sortZone}</TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.plannedBags}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.closedBags}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.openBags}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.ovUsage}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.plannedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.receivedPackages, sortZone, PackageStatus.CURRENT_RECEIVED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.inductedPackages, sortZone, PackageStatus.CURRENT_INDUCTED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.stowedPackages, sortZone, PackageStatus.STOWED)}
                </TableCell>
                {bagsData && bagsData[sortZone] && bagsData[sortZone].length ? bagsData[sortZone].map(bag => (
                        <TableRow>
                            <TableCell columnSpan={4}>
                                <FormattedMessage id="sortZone.bag"
                                                  defaultMessage="Bag"/> {bag.bagLabel} ({bag.state}): {bag.childCount} packages
                            </TableCell>
                        </TableRow>
                    )) :
                    <TableRow/>}
            </TableRow>
        )
    }

    getCombinedMetricsMap = sortZone => {
        const {
            stowPackageMetricsMap, inductPackageMetricsMap, ovUsageMap, stowBagMetricsMap
        } = this.props;
        const defaultMetricValue = "-"

        return {
            sortZone: sortZone,
            plannedBags: getOrDefaultValueForCell(stowBagMetricsMap, sortZone, "plannedBags"),
            closedBags: getOrDefaultValueForCell(stowBagMetricsMap, sortZone, "closedBags"),
            openBags: getOrDefaultValueForCell(stowBagMetricsMap, sortZone, "openBags"),
            plannedPackages: chainWalk(() => stowPackageMetricsMap[sortZone].plannedPackages, defaultMetricValue),
            receivedPackages: chainWalk(() => inductPackageMetricsMap[sortZone].receivedPackages, defaultMetricValue),
            inductedPackages: chainWalk(() => stowPackageMetricsMap[sortZone].currentInductedPackages, defaultMetricValue),
            stowedPackages: chainWalk(() => stowPackageMetricsMap[sortZone].stowedPackages, defaultMetricValue),
            ovUsage: chainWalk(() => ovUsageMap[sortZone].ovUsage + '%', defaultMetricValue)
        }
    }

    clickSortZoneRow = sortZone => {

        this.setState((oldState) => {
            if (oldState.expandedSortZones.indexOf(sortZone) !== -1) {
                return {
                    expandedSortZones: oldState.expandedSortZones.filter(expandedSortZone => expandedSortZone !== sortZone)
                }
            } else {
                this.props.dispatch(fetchBagsDataForSortZone(getNodeId(), [this.props.options.cycle], sortZone));
                return {
                    expandedSortZones: oldState.expandedSortZones.concat(sortZone)
                }
            }
        })
    }

    isSortZoneExpanded = sortZone => {
        return (this.state.expandedSortZones.indexOf(sortZone) !== -1);
    }

    renderPackageCount = (value, sortZone, state) => {
        return value !== 0 && value !== '-' ?
            <Link href={this.getPackageListURL(state, sortZone)}
                  type="secondary"> {value} </Link> : value
    }

    getPackageListURL = (state, sortZone) => {
        const {navigationOptions, options} = this.props
        const params = {
            PACKAGE_STATUS: state,
            BIN: sortZone,
            AISLE: navigationOptions[1].value
        }
        if (options.cycle) {
            params["CYCLE"] = options.cycle;
        }
        return "#packageList/?" + formQueryParams(params);
    }

    isDRSStowVisibilityEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.DRS_STOW_VISIBILITY];
    }
}

const mapStateToProps = state => ({
    loading: state.sortZoneReducer.loading,
    error: state.sortZoneReducer.error,
    navigationOptions: state.optionsReducer.navigationOptions,
    options: state.optionsReducer.options,
    stowPackageMetricsMap: state.sortZoneReducer.stowPackageMetricsMap,
    stowBagMetricsMap: state.sortZoneReducer.stowBagMetricsMap,
    inductPackageMetricsMap: state.sortZoneReducer.inductPackageMetricsMap,
    bagsData: state.sortZoneReducer.bagsData,
    ovUsageMap: state.sortZoneReducer.stowOvUsageMap,
    featureStatus: state.configReducer.featureStatus
});
export default withRouter(connect(mapStateToProps)(SortZone));



// WEBPACK FOOTER //
// ./src/components/SortZone.js